import { CheckCircle } from "lucide-react";
import { useLanguage } from "@/i18n/LanguageContext";
import type { TranslationKey } from "@/i18n/translations";

const WhoIWorkWithSection = () => {
  const { t } = useLanguage();

  const situationKeys: TranslationKey[] = [
    "who.item1",
    "who.item2",
    "who.item3",
    "who.item4",
    "who.item5",
  ];

  return (
    <section id="who-i-work-with" className="py-24 bg-secondary/30">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12 space-y-4">
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tighter">
              {t("who.title")}
            </h2>
            <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
              {t("who.subtitle")}
            </p>
          </div>

          <div className="space-y-5">
            {situationKeys.map((key) => (
              <div
                key={key}
                className="flex items-start gap-4 p-5 bg-background rounded-sm border border-border/50 hover:shadow-md transition-shadow"
              >
                <CheckCircle className="h-6 w-6 text-accent flex-shrink-0 mt-0.5" />
                <p className="text-foreground/90 text-lg leading-relaxed font-serif">
                  {t(key)}
                </p>
              </div>
            ))}
          </div>

          <div className="mt-12 text-center">
            <p className="text-muted-foreground text-base max-w-2xl mx-auto">
              {t("who.footnote")}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhoIWorkWithSection;
